export const EVENT_COMPARISON_LIST = 'EVENT_COMPARISON_LIST';
export const EVENT_COMPARISON_LIST_SUCCESS = 'EVENT_COMPARISON_LIST_SUCCESS';
export const EVENT_COMPARISON_LIST_ERROR = 'EVENT_COMPARISON_LIST_ERROR';

export const EVENT_COMPARISON_DETAILS = 'EVENT_COMPARISON_DETAILS';
export const EVENT_COMPARISON_DETAILS_SUCCESS = 'EVENT_COMPARISON_DETAILS_SUCCESS';
export const EVENT_COMPARISON_DETAILS_ERROR = 'EVENT_COMPARISON_DETAILS_ERROR';

export const ADD_EVENT_COMPARISON_DETAILS = 'ADD_EVENT_COMPARISON_DETAILS';
export const ADD_EVENT_COMPARISON_DETAILS_SUCCESS = 'ADD_EVENT_COMPARISON_DETAILS_SUCCESS';
export const ADD_EVENT_COMPARISON_DETAILS_ERROR = 'ADD_EVENT_COMPARISON_DETAILS_ERROR';

export const UPDATE_EVENT_COMPARISON = 'UPDATE_EVENT_COMPARISON';
export const UPDATE_EVENT_COMPARISON_SUCCESS = 'UPDATE_EVENT_COMPARISON_SUCCESS';
export const UPDATE_EVENT_COMPARISON_ERROR = 'UPDATE_EVENT_COMPARISON_ERROR';

export const DELETE_EVENT_COMPARISON = 'DELETE_EVENT_COMPARISON';
export const DELETE_EVENT_COMPARISON_SUCCESS = 'DELETE_EVENT_COMPARISON_SUCCESS';
export const DELETE_EVENT_COMPARISON_ERROR = 'DELETE_EVENT_COMPARISON_ERROR';
